import * as React from 'react';

type Props = {
  className?: string;
};

const HeartLineIcon: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    overflow="visible"
    width="64px"
    height="64px"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M46.67188,7.46874 C43.02604,7.46874 39.77083,8.51040667 36.90625,10.59374 C35.8645833,11.5052 34.4973967,11.96093 32.80469,11.96093 C31.24219,11.96093 29.9401067,11.5052 28.89844,10.59374 C26.0338533,8.51040667 22.7786433,7.46874 19.13281,7.46874 C14.70573,7.46874 10.8645867,9.12889667 7.60938,12.44921 C4.35416667,15.7695233 2.72656,19.7083267 2.72656,24.26562 C2.72656,33.9010333 11.5156233,44.3177 29.09375,55.51562 C30.2656233,56.2968733 31.5026033,56.6875 32.80469,56.6875 C34.10677,56.6875 35.3437467,56.2968733 36.51562,55.51562 C54.0937467,44.3177 62.88281,33.9010333 62.88281,24.26562 C63.0130167,19.7083267 61.48307,15.7695233 58.29297,12.44921 C55.1028633,9.12889667 51.2291667,7.46874 46.67188,7.46874 Z M35.14844,53.17187 C34.4974,53.5624967 33.8463567,53.75781 33.19531,53.75781 C32.28385,53.75781 31.5677067,53.5624967 31.04688,53.17187 C14.3802067,42.1041633 6.04688,32.4687467 6.04688,24.26562 C6.04688,20.48958 7.34896333,17.23437 9.95313,14.49999 C12.5572967,11.7656167 15.6822933,10.39843 19.32812,10.39843 C22.1927067,10.39843 24.86198,11.30989 27.33594,13.13281 C28.89844,14.3046833 30.8515633,14.89062 33.19531,14.89062 C35.40885,14.89062 37.2968733,14.3046833 38.85938,13.13281 C41.07292,11.30989 43.6770867,10.39843 46.67188,10.39843 C49.9270867,10.39843 52.98698,11.7005133 55.85156,14.30468 C58.5859333,17.0390533 59.95312,20.3593667 59.95312,24.26562 C59.95312,32.72916 51.6848933,42.3645767 35.14844,53.17187 Z"
        fill="#1A1919"
      />
    </g>
  </svg>
);

export default HeartLineIcon;
